<div class="chat-container flex overflow-hidden relative"> <!-- Added relative for mobile positioning -->
    
    <!-- Left Sidebar -->
    <!-- On Mobile: Show ONLY if NO active conversation -->
    <!-- On Desktop: Always show -->
    <div class="flex-none h-full transition-all duration-300" 
         [class.hidden]="(state.activeConversation$ | async) && isMobileView"
         [class.w-full]="isMobileView"
         [style.width]="isMobileView ? '100%' : '350px'">
        <app-chat-sidebar></app-chat-sidebar>
    </div>

    <!-- Main Window -->
    <!-- On Mobile: Show ONLY if active conversation -->
    <!-- On Desktop: Always show -->
    <div class="flex-1 min-w-0 border-left-1 border-gray-200 h-full transition-all duration-300"
         [class.hidden]="!(state.activeConversation$ | async) && isMobileView">
        <app-chat-window></app-chat-window>
    </div>

    <!-- Right Info (300px - Placeholder/Commented as requested) -->
    <!-- 
    <div class="flex-none bg-white border-left-1 border-gray-200" style="width: 300px;">
        <app-chat-info></app-chat-info>
    </div> 
    -->
</div>
